import React, { useCallback, useEffect, useState } from "react";
import "./App.css";

import Grain from "./components/Grain";
import Lens from "./components/Lens";
import Preloader from "./components/Preloader";
import HUD from "./components/HUD";
import Hero from "./components/Hero";
import Method from "./components/Method";
import Work from "./components/Work";
import Counts from "./components/Counts";
import Contact from "./components/Contact";

import useReveal from "./hooks/useReveal";
import useReducedMotion from "./hooks/useReducedMotion";

export default function App() {
  const reduced = useReducedMotion();
  const [ready, setReady] = useState(reduced);
  const [act, setAct] = useState("top");
  const [indexOpen, setIndexOpen] = useState(false);

  useReveal([ready]);

  /* Which act is on screen — drives the HUD counter. */
  useEffect(() => {
    const sections = document.querySelectorAll("[data-act]");
    if (!sections.length) return undefined;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setAct(e.target.dataset.act);
        });
      },
      { rootMargin: "-45% 0px -45% 0px" }
    );

    sections.forEach((s) => io.observe(s));
    return () => io.disconnect();
  }, [ready]);

  /* The page's colour identity, handed over to whichever app holds the stage. */
  const applyTheme = useCallback((theme) => {
    const root = document.documentElement;
    if (theme === "studio") root.removeAttribute("data-theme");
    else root.setAttribute("data-theme", theme);
  }, []);

  const jump = useCallback((id) => {
    setIndexOpen(false);
    const el = document.getElementById(id);
    if (!el) return;
    // Smooth here only, so authored scroll-scrubbing elsewhere stays honest.
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  useEffect(() => {
    document.body.style.overflow = indexOpen ? "hidden" : "";
  }, [indexOpen]);

  return (
    <>
      {!reduced && !ready && <Preloader onDone={() => setReady(true)} />}

      <Grain />
      <Lens />

      <HUD act={act} open={indexOpen} onToggle={setIndexOpen} onJump={jump} />

      <main className={`shell${ready ? " is-ready" : ""}`}>
        <Hero ready={ready} />
        <Method />
        <Work onTheme={applyTheme} />
        <Counts />
        <Contact />
      </main>
    </>
  );
}
